import './App.scss';
import './contact-footer.scss';
import vars from './vars.scss';
import GoogleMapEmbed from './components/GoogleMapEmbed';
import { IoIosMenu } from 'react-icons/io';
import { RxCross1 } from 'react-icons/rx';
import { AdminLayout } from './admin/AdminLayout';

import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { ArticleContainer } from './ArticleContainer';
import { useEffect, useState } from 'react';

function App() {
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();
  console.log('location: ', location);

  // Handle anchor scrolling after navigation
  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      // Get the element by id (without the #)
      const element = document.getElementById(location.hash.substring(1));

      // If the element exists, scroll to it
      if (element) {
        setTimeout(() => {
          const yOffset = -35; // 100px offset from the top
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({
            top: y,
            behavior: 'smooth',
          });
        }, 100); // Small delay to ensure the page has rendered
      }
    } else {
      // If no hash, scroll to top
      window.scrollTo(0, 0);
    }
  }, [location]);

  // TODO: needs google api key
  // const initMap = () => {
  //   const location = { lat: 51.1151265, lng: 17.0258731 }; // Target location
  //
  //   const map = new google.maps.Map(document.getElementById('map'), {
  //     center: location,
  //     zoom: 14,
  //     styles: [
  //       {
  //         featureType: 'all',
  //         elementType: 'geometry',
  //         stylers: [{ saturation: -100 }, { lightness: 50 }],
  //       },
  //       {
  //         featureType: 'road',
  //         elementType: 'geometry',
  //         stylers: [{ visibility: 'simplified' }],
  //       },
  //       {
  //         featureType: 'water',
  //         elementType: 'geometry',
  //         stylers: [{ color: '#ffffff' }],
  //       },
  //     ],
  //   });
  //
  //   const marker = new google.maps.Marker({
  //     position: location,
  //     map: map,
  //     icon: {
  //       url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png', // Red pin
  //     },
  //   });
  //
  //   marker.addListener('click', function () {
  //     window.location.href =
  //       'https://www.google.com/maps/place/Magdalena+Pawlak+Kancelaria+Radcy+Prawnego/@51.1151006,17.0168652,16z/data=!4m6!3m5!1s0x470fe91aaaf5716f:0x43fa4d64c35b4ed3!8m2!3d51.1151265!4d17.0258731!16s%2Fg%2F11vzwpt73y?entry=ttu&g_ep=EgoyMDI1MDMwMi4wIKXMDSoASAFQAw%3D%3D';
  //   });
  // };

  const route = (() => {
    const path = location.pathname
      .split('/')
      .slice(1)
      .join('/')
      .replace(/\/$/, '');
    console.log('path2: ', path);
    if (/blog\/.+/.test(path)) {
      return 'concrete-blog';
    }
    if (path.startsWith('uslugi/')) {
      return 'services';
    }
    switch (path) {
      case 'o-mnie':
        return 'about';
      case 'zakres-uslug':
        return 'services';
      case 'wynagrodzenie':
        return 'offer';
      case 'kontakt':
        return 'contact';
      case 'blog':
        return 'blog';
      default:
        return 'main';
    }
  })();
  function resizeText() {
    const parent = document.querySelector('.subsite-header');
    const child = document.querySelector('.subsite-header h2');
    if (!child) return;
    if (!parent) return;

    const mobileSwitch = (route) => {
      switch (route) {
        case 'main':
          return 0.8;
        case 'about':
          return 0.48;
        case 'services':
          return 0.5;
        case 'blog':
          return 0.7;
        case 'contact':
          return 0.66;
        case 'concrete-blog':
          return 0.7;
        default:
          return 0.95;
      }
    };

    const tabletSwitch = (route) => {
      switch (route) {
        // case 'main':
        //   return 0.7;
        // case 'services':
        //   return 0.4;
        default:
          return;
      }
    };

    const desktopSwitch = (route) => {
      switch (route) {
        // case 'main':
        //   return 0.8;
        default:
          return;
        //return 0.7;
      }
    };

    const factor = (() => {
      let mobile;
      if (parseInt(vars.secondBreakPoint) > window.innerWidth) {
        mobile = mobileSwitch(route);
      }
      let tablet;
      if (!mobile) {
        tablet = tabletSwitch(route);
      }
      let desktop;
      if (!tablet && !mobile) {
        desktop = desktopSwitch(route);
      }
      return mobile || tablet || desktop;
    })();
    if (!factor) {
      child.style.removeProperty('font-size');
      return;
    }
    let fontSize = 20; // Start with a large font size
    child.style.fontSize = fontSize + 'px';
    console.log(child.style.fontSize);
    while (child.scrollWidth < parent.clientWidth * factor && fontSize > 10) {
      fontSize += 4;
      child.style.fontSize = fontSize + 'px';
    }
  }

  useEffect(() => {
    resizeText();
  }, [route]);

  // Admin panel: bypass the entire main-site layout
  if (location.pathname.startsWith('/admin')) {
    return <AdminLayout />;
  }

  const hideClassIfBlogsPage = route === 'blog' ? 'hide' : '';
  const hideClassIfBlog = route === 'concrete-blog' ? 'hide' : '';
  const isConcreteBlogPage = route === 'concrete-blog';

  window.addEventListener('load', resizeText);
  window.addEventListener('resize', resizeText);

  return (
    <div className="root">
      <div className="top-line"></div>
      <h1 className="logo">
        <span>Kancelaria Radcy Prawnego</span>
        <span>kompleksowa pomoc prawna</span>
      </h1>
      <nav>
        <ul className={!showMenu && 'hide-menu'}>
          <li>
            <Link to="/" onClick={() => setShowMenu(false)}>
              strona główna
            </Link>
          </li>
          <li>
            <Link to="/o-mnie" onClick={() => setShowMenu(false)}>
              o mnie
            </Link>
          </li>
          <li>
            <Link to="/zakres-uslug" onClick={() => setShowMenu(false)}>
              zakres usług
            </Link>
          </li>
          <li>
            <Link to="/wynagrodzenie" onClick={() => setShowMenu(false)}>
              wynagrodzenie
            </Link>
          </li>
          <li>
            <Link to="/kontakt" onClick={() => setShowMenu(false)}>
              kontakt
            </Link>
          </li>
          {/*<li>*/}
          {/*  <Link to="/blog" onClick={() => setShowMenu(false)}>*/}
          {/*    blog*/}
          {/*  </Link>*/}
          {/*</li>*/}
        </ul>
        <div className="btn-mobile-nav">
          <IoIosMenu
            onClick={() => {
              setShowMenu(!showMenu);
            }}
            className={showMenu ? 'hide' : ''}
            size={30}
            style={{
              color: vars.baseColor,
            }}
          />
          <RxCross1
            className={showMenu ? '' : 'hide'}
            onClick={() => {
              setShowMenu(!showMenu);
            }}
            size={30}
            style={{
              color: vars.baseColor,
            }}
          />
        </div>
      </nav>
      <div className="main-grid">
        {!isConcreteBlogPage && (
          <>
            <div
              className={`${hideClassIfBlogsPage} ${hideClassIfBlog} dark-side-block left-margin`}
            ></div>
            <div
              className={`${hideClassIfBlogsPage} ${hideClassIfBlog} top-photos${route ? '-' + route : ''} photo-tile top-left-photo-tile`}
            ></div>
            <div
              className={`${hideClassIfBlogsPage} ${hideClassIfBlog} top-photos${route ? '-' + route : ''} photo-tile top-mid-photo-tile`}
            ></div>
            <div
              className={`${hideClassIfBlogsPage} ${hideClassIfBlog} top-photos${route ? '-' + route : ''} photo-tile top-right-photo-tile`}
            ></div>
            <div
              className={`${hideClassIfBlogsPage} dark-side-block right-margin`}
            ></div>
          </>
        )}
        <div className="light-side-block left-margin"></div>
        <main>
          <header className="subsite-header">
            <Routes>
              <Route
                exact
                path="/"
                element={<h2 className={'main'}>radca</h2>}
              />
              <Route
                exact
                path="/o-mnie"
                element={<h2 className={'about'}>o mnie</h2>}
              />
              <Route
                exact
                path="/zakres-uslug"
                element={<h2 className={'services'}>usługi</h2>}
              />
              <Route
                path="/uslugi/*"
                element={<h2 className={'services'}>usługi</h2>}
              />
              <Route
                exact
                path="/wynagrodzenie"
                element={<h2 className={'offer'}>honorarium</h2>}
              />
              <Route
                exact
                path="/kontakt"
                element={<h2 className={'contact'}>kontakt</h2>}
              />
              <Route
                exact
                path="/blog"
                element={<h2 className={'blog'}>blog</h2>}
              />
              <Route
                exact
                path="/blog/*"
                element={<h2 className={'blog'}>blog</h2>}
              />
            </Routes>
            <div className={'lawyer-signature'}>
              <p>MAGDALENA PAWLAK</p>
            </div>
          </header>
          <Routes>
            <Route exact path="/" element={<ArticleContainer tab="main" />} />
            <Route
              exact
              path="/o-mnie"
              element={<ArticleContainer tab="about" />}
            />
            <Route
              exact
              path="/zakres-uslug"
              element={<ArticleContainer tab="services" />}
            />
            <Route
              path="/uslugi/:slug"
              element={<ArticleContainer tab="service" />}
            />
            <Route
              exact
              path="/wynagrodzenie"
              element={<ArticleContainer tab="offer" />}
            />
            <Route
              exact
              path="/kontakt"
              element={<ArticleContainer tab="contact" />}
            />
            <Route
              exact
              path="/blog"
              element={<ArticleContainer tab="blogs" />}
            />
            <Route
              exact
              path="/blog/:slug"
              element={<ArticleContainer tab="blog" />}
            />
          </Routes>
        </main>
        <div className={`light-side-block right-margin`}></div>
        <div
          className={`${hideClassIfBlogsPage} dark-side-block left-margin`}
        ></div>
        <div
          className={`${hideClassIfBlogsPage} bottom-photos${route ? '-' + route : ''} photo-tile bottom-left-photo-tile`}
        ></div>
        <div className={`${hideClassIfBlogsPage} google-maps-tile`}>
          <GoogleMapEmbed />
          <div className={'google-maps-info-tile'}>
            <div className={'show-on-desktop'}>
              <a
                href={'https://maps.app.goo.gl/GvK1JpjvpHCNoSnf7'}
                target={'_blank'}
              >
                <p className={'show-on-desktop'}>Otwórz w Google Maps</p>
                <p className={'show-on-mobile'}>Otwórz</p>
                <p className={'show-on-mobile'}>Google Maps</p>
              </a>
            </div>
          </div>
        </div>
        {/*<div className="google-maps-tile">*/}
        {/*</div>*/}
        {/*<div className="pin-map" alt="Red Pin"></div>*/}
        {/*</div>*/}
        <div
          className={`${hideClassIfBlogsPage} bottom-photos${route ? '-' + route : ''} photo-tile bottom-right-photo-tile`}
        ></div>
        <div
          className={`${hideClassIfBlogsPage} dark-side-block right-margin`}
        ></div>
        <div></div>
        <div className="email-tile contact-tile">
          <div className="email-icon icon"></div>
          <span>E-mail</span>
          <a
            href={'mailto:kancelaria@radcaprawnypawlak.pl'}
            target={'_blank'}
            className="tile-content"
          >
            kancelaria@radcaprawnypawlak.pl
          </a>
        </div>
        <div className="address-tile contact-tile">
          <div className="home-icon icon"></div>
          <span>Adres</span>
          <div className={'tile-content'}>
            ul. Księcia Witolda 38-40/2
            <br /> 50-202 Wrocław
          </div>
        </div>
        <div className="phone-number-tile contact-tile">
          <div className="phone-icon icon"></div>
          <span>Telefon</span>
          <a className={'tile-content'} href={'tel:531173467'}>
            +48 531 173 467
          </a>
        </div>
        <div></div>
      </div>
      <footer className="main-footer">
        {/*  <div className="footer-container">*/}
        {/*    <div className="left-margin"></div>*/}

        {/*    <div className="footer-logo">*/}
        {/*      <div className="logo">*/}
        {/*        <span>Kancelaria Radcy Prawnego</span>*/}
        {/*        <span>kompleksowa pomoc prawna</span>*/}
        {/*      </div>*/}
        {/*    </div>*/}

        {/*    <div className="footer-services">*/}
        {/*      <h2>Zakres usług</h2>*/}
        {/*      <ul>*/}
        {/*        <li>*/}
        {/*          <Link to="/zakres-uslug#odszkodowania">Odszkodowania</Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/zakres-uslug#prawo-rodzinne">Prawo rodzinne</Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/zakres-uslug#kredyty-frankowe">*/}
        {/*            Kredyty frankowe*/}
        {/*          </Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/zakres-uslug#prawo-pracy">Prawo pracy</Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/zakres-uslug#prawo-karne">Prawo karne</Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/zakres-uslug#prawo-cywilne">Prawo cywilne</Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/zakres-uslug#prawo-spadkowe">Prawo spadkowe</Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/zakres-uslug#roboty-budowlane">*/}
        {/*            Roboty budowlane*/}
        {/*          </Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/zakres-uslug#obsluga-spolek">Obsługa spółek</Link>*/}
        {/*        </li>*/}
        {/*      </ul>*/}
        {/*    </div>*/}

        {/*    <div className="footer-kancelaria">*/}
        {/*      <h2>Kancelaria</h2>*/}
        {/*      <ul>*/}
        {/*        <li>*/}
        {/*          <Link to="/">Strona główna</Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/o-mnie">O mnie</Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/zakres-uslug">Zakres usług</Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/wynagrodzenie">Wynagrodzenie</Link>*/}
        {/*        </li>*/}
        {/*        <li>*/}
        {/*          <Link to="/kontakt">Kontakt</Link>*/}
        {/*        </li>*/}
        {/*      </ul>*/}
        {/*    </div>*/}

        {/*    <div className="right-margin"></div>*/}
        {/*  </div>*/}
        <div className="footer-bottom">
          <div>
            &copy; {'2022'} Kancelaria Radcy Prawnego Magdalena Pawlak | Wrocław
            - Jastrzębie-Zdrój | Poland
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
